export default __webpack_public_path__ + "static/media/emotion-m@2x.93ba6433.png";